import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LoadingState } from '../../designacoes/modal/designacao/components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 12px 48px rgba(0,0,0,0.22);
  width: 90vw;
  max-width: 700px;
  max-height: 90vh;
  overflow: auto;
  padding: 0 0 16px 0;
  position: relative;
    
  @media (max-width: 768px) {
    width: 95vw;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px 0 32px;
  font-size: 18px;
  font-weight: 500;
  color: #9CA3AF;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #666;
`;

const ExperienciaCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  margin: 18px 32px 0 32px;
  padding: 18px 18px 12px 18px;
`;

const Nome = styled.div`
  color: #009688;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
`;

const Texto = styled.div`
  color: #444;
  font-size: 15px;
  margin-bottom: 8px;
`;

const VerMais = styled.button`
  background: none;
  border: none;
  color: #009688;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 18px 32px 0 32px;
  font-size: 15px;
  color: #888;
`;

const Paginacao = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PaginaInput = styled.input`
  width: 32px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 15px;
  margin: 0 4px;
`;

const ModalExperiencias = ({ isOpen, onClose, experiencias = [], carregando = false }) => {
  const [pagina, setPagina] = useState(1);
  const [expandedItems, setExpandedItems] = useState({}); // Controle local de expansão
  const porPagina = 2;
  const totalPaginas = Math.ceil(experiencias.length / porPagina) || 1;

  useEffect(() => {
    if (isOpen) {
      setPagina(1);
      setExpandedItems({});
    }
  }, [isOpen, experiencias]);

  useEffect(() => {
    if (pagina > totalPaginas) {
      setPagina(totalPaginas);
    }
  }, [pagina, totalPaginas]);

  if (!isOpen) return null;

  const handleChangePagina = (e) => {
    let val = parseInt(e.target.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > totalPaginas) val = totalPaginas;
    setPagina(val);
  };

  const toggleExpand = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const experienciasPagina = experiencias.slice((pagina-1)*porPagina, pagina*porPagina);

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '4px', height: '20px', background: '#009688', borderRadius: '4px' }}></div>
            Relatos de Experiências
          </div>
          <CloseButton onClick={onClose} title="Fechar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </CloseButton>
        </ModalHeader>
        {carregando ? (
          <LoadingState />
        ) : experiencias.length === 0 ? (
          <div style={{ padding: '32px', textAlign: 'center', color: '#666' }}>
            Nenhuma experiência encontrada.
          </div>
        ) : (
          experienciasPagina.map((exp, idx) => {
            const realIndex = idx + (pagina - 1) * porPagina;
            const isExpanded = !!expandedItems[realIndex];
            const texto = typeof exp?.texto === 'string' ? exp.texto : '';
            const nome = exp?.nome || 'Anônimo';
            const congregacao = exp?.congregacao || '';

            return (
              <ExperienciaCard key={exp?.id || realIndex}>
                <Nome>
                  {nome}
                  {congregacao ? (
                    <span style={{ color: '#3B4B5A', fontWeight: 400, fontSize: 14 }}> ({congregacao})</span>
                  ) : null}
                </Nome>
                <Texto>
                  {texto.length > 200 && !isExpanded
                    ? texto.slice(0, 200) + '...'
                    : texto || 'Sem relato informado.'}
                </Texto>
                {texto.length > 200 && (
                  <VerMais onClick={() => toggleExpand(realIndex)}>
                    {isExpanded ? 'Ver menos' : 'Ver mais'}
                  </VerMais>
                )}
              </ExperienciaCard>
            );
          })
        )}
        {experiencias.length > 0 && (
          <Footer>
            <Paginacao>
              Página:
              <PaginaInput type="number" min={1} max={totalPaginas} value={pagina} onChange={handleChangePagina} />
              de {totalPaginas}
              {pagina > 1 && (
                <button style={{ marginLeft: 8, background: 'none', border: 'none', color: '#009688', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setPagina(pagina-1)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                </button>
              )}
              {pagina < totalPaginas && (
                <button style={{ marginLeft: 8, background: 'none', border: 'none', color: '#009688', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setPagina(pagina+1)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                </button>
              )}
            </Paginacao>
          </Footer>
        )}
      </ModalContainer>
    </Overlay>
  );
};

export default ModalExperiencias;
